<template>
  <ul class="p-i-conditions-list">
    <li
      v-for="(conditionsDetail, key) in conditionsList"
      class="p-i-conditions-list__item"
      :key="key"
    >
      <IConditionsListPanel :conditions-detail="conditionsDetail" />
    </li>
  </ul>
</template>

<script lang="ts">
import { mapState } from "vuex";
import { Options, Vue } from 'vue-class-component';
import IConditionsListPanel from "@/general/components/pages/parts/GrantCriteriaList/IConditionsListPanel.vue";

@Options({
  props: {
	conditionsList: { type: Array, default: () => ([]), required: true }
  },
  components: {
    IConditionsListPanel
  }
})
export default class IConditionsList extends Vue {
  conditionsList!: [];
}
</script>

<style lang="scss" scoped>
.p-i-conditions-list {
  &__item {
    border-bottom: px(1) solid $common-gray300;
  }
}
</style>
